<template>
  <b-card>
	  <!-- 头像 -->
	  <b-media class="mb-2">
	    <template #aside>
	      <b-avatar
	        ref="previewEl"
	        :src="avatar"
	        size="90px"
	        rounded
	      />
	    </template>
	    <h4 class="mb-1">
	      {{ userData.userName }}
	    </h4>
	    <div class="d-flex flex-wrap">
	      <b-button
	        variant="primary"
	        @click="$refs.refInputEl.click()"
	      >
	        <input
	          ref="refInputEl"
	          type="file"
	          class="d-none"
			  @change="uploadFile"
	        >
	        <span class="d-none d-sm-inline">{{$t('Update Avatar')}}</span>
	        <feather-icon
	          icon="EditIcon"
	          class="d-inline d-sm-none"
	        />
	      </b-button>
	    </div>
	  </b-media>
		  
	    <validation-observer ref="addUserRules">
	  	
	  	  <b-form @submit.prevent>
	  	    <b-row>
	  		  <!-- 用户名 -->
	  	      <b-col md="6">
	  	        <b-form-group :label="$t('User Name')" class="required-field">
	  	  		<validation-provider
	  	  		  #default="{ errors }"
	  	  		  :name="$t('User Name')"
	  	  		  rules="required"
	  	  		>
	  	  		  <b-form-input 
				  :placeholder="$t('Please input')+$t('User Name')"
				  v-model="userData.userName"/>
	  	  		  <small class="text-danger">{{ errors[0] }}</small>
	  	  		</validation-provider>  
	  	        </b-form-group>
	  	      </b-col>
	  	    
	  		<!-- 密码 -->  
	  	  	<b-col md="6">
	  	  	  <b-form-group :label="$t('Password')" :class="isEdit?'':'required-field'">
	  	  		<validation-provider
	  	  		  #default="{ errors }"
	  	  		  :name="$t('Password')"
	  	  		  :rules="isEdit?'':'required'"
	  	  		>
				  <b-input-group>
				    <b-form-input
					  :placeholder="$t('Please input')+$t('Password')" 
					  v-model="userData.password"
				      id="basic-password"
				      :type="passwordFieldType"
				    />
				    <b-input-group-append is-text>
				      <feather-icon
				        :icon="passwordToggleIcon"
				        class="cursor-pointer"
				        @click="togglePasswordVisibility"
				      />
				    </b-input-group-append>
				  </b-input-group>
				  
	  	  		  <!--<b-form-input :state="errors.length>0?false:null" placeholder="" v-model="userData.password"/>-->
	  	  		  <small class="text-danger">{{ errors[0] }}</small>
	  	  		</validation-provider>   
	  	  	  </b-form-group>
	  	  	</b-col>
	  		
	  		<!-- FirstName -->
	  		<b-col md="6">
	  			<b-form-group
	  			  :label="$t('First Name')"
	  			>
	  			  <b-form-input
				    :placeholder="$t('Please input')+$t('First Name')" 
	  			    id="first-name"
	  			    v-model="userData.firstName"
	  			    trim
	  			  />
	  			</b-form-group>
	  		</b-col>
	  		
	  		<!-- LastName -->
	  		<b-col md="6">
	  			<b-form-group
	  			  :label="$t('Last Name')"
	  			>
	  			  <b-form-input
				    :placeholder="$t('Please input')+$t('Last Name')" 
	  			    id="last-name"
	  			    v-model="userData.lastName"
	  			    trim
	  			  />
	  			</b-form-group>
	  		</b-col>
	  		
	  		<!-- 性别 -->
	  		<!--<b-col md="6">
	  			<b-form-group
	  			  :label="$t('Gender')"
	  			  label-for="gender"
	  			>
	  			  <b-form-input
				    :placeholder="$t('Please input')+$t('Gender')" 
	  			    id="gender"
	  			    v-model="userData.gender"
	  			    trim
	  			  />
	  			</b-form-group>
	  		</b-col>-->
	  		
	  		<!-- 国籍 -->
	  		<!--<b-col md="6">
	  			<b-form-group
	  			  :label="$t('Nationality')"
	  			  label-for="gender"
	  			>
	  			  <b-form-input
	  			    id="nationality"
	  			    v-model="userData.nationality"
	  			    trim
	  			  />
	  			</b-form-group>
	  		</b-col>-->
	  		
	  		<!-- 公司 -->
	  		<b-col md="6">
	  			<b-form-group
	  			  :label="$t('Company')"
	  			>
	  			  <b-form-input
				    :placeholder="$t('Please input')+$t('Company')" 
	  			    id="company"
	  			    v-model="userData.company"
	  			    trim
	  			  />
	  			</b-form-group>
	  		</b-col>
	  		
	  		<!-- 部门 -->
	  		<b-col md="6">
	  			<b-form-group
	  			  :label="$t('Department')"
	  			>
	  			  <b-form-input
				    :placeholder="$t('Please input')+$t('Department')" 
	  			    id="department"
	  			    v-model="userData.department"
	  			    trim
	  			  />
	  			</b-form-group>
	  		</b-col>
	   
	  		<!-- 邮箱 -->
	  		<b-col md="6">
	  			<validation-provider
	  			  #default="{ errors }"
	  			  name="Email"
	  			  rules="email"
	  			>
	  			  <b-form-group
	  			    :label="$t('Email')"
	  			  >
	  			    <b-form-input
					  :placeholder="$t('Please input')+$t('Email')" 
	  			      id="email"
	  			      v-model="userData.email"
	  			      trim
	  			    />
	  			    <small class="text-danger">{{ errors[0] }}</small>
	  			  </b-form-group>
	  			</validation-provider>
	  		</b-col>
	  		
	  		<!-- 角色 -->
	  		<b-col md="6">
	  			<validation-provider
	  			  #default="{ errors }"
	  			  :name="$t('Role')"
	  			  rules="required"
	  			>
	  			  <b-form-group
	  			    :label="$t('Role')"
	  			    class="required-field"
	  			  >
	  			    <v-select
					  :placeholder="$t('Please select')+$t('Role')" 
	  			      v-model="userData.roleIdentifier"
	  			      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
	  			      :options="roleOptions"
	  				  label="userRolesString"
	  			      :reduce="userRolesString => userRolesString.userRolesIdentifier"
	  			      :clearable="false"
	  			      input-id="user-role"
	  			    />
	  			    <small class="text-danger">{{ errors[0] }}</small>
	  			  </b-form-group>
	  			</validation-provider>
	  		</b-col>
	  		
	  		<!-- 用户组 -->
	  		<b-col md="6">
	  			<validation-provider
	  			  #default="{ errors }"
	  			  :name="$t('Group')"
	  			  rules="required"
	  			>
	  			  <b-form-group
	  			    :label="$t('Group')"
	  			    class="required-field"
	  			  >
	  			    <v-select
					  :placeholder="$t('Please select')+$t('Group')" 
	  			      v-model="userData.group"
	  			      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
	  			      :options="groupOptions"
	  			      :clearable="false"
	  			      input-id="user-role"
	  			    />
	  			    <small class="text-danger">{{ errors[0] }}</small>
	  			  </b-form-group>
	  			</validation-provider>
	  		</b-col>
			
			<!-- 语言 -->
			<b-col md="6">
				<validation-provider
				  #default="{ errors }"
				  name="Language"
				  rules="required"
				>
				  <b-form-group
				    :label="$t('Language')"
				    class="required-field"
				  >
				    <v-select
				      v-model="userData.language"
				      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
				      :options="langOptions"
					  label="label"
				      :reduce="label => label.id"
				      :clearable="false"
				      input-id="language"
				    />
				    <small class="text-danger">{{ errors[0] }}</small>
				  </b-form-group>
				</validation-provider>
			</b-col>
	  		
	  		
	  	  
	  	      <b-col md="12">
	  	        <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
	  	          {{$t("Submit")}}
	  	        </b-button>
	  	        <b-button type="reset" variant="outline-secondary">
	  	          {{$t("Reset")}}
	  	        </b-button>
	  	      </b-col>
	  	    </b-row>
	  	  </b-form>
	  	  	
	  		
	    </validation-observer>	
	  	  	  
		  
  </b-card>	

</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import {
  BMedia, BCard, BAvatar, BRow, BCol, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormCheckbox, BForm, BButton,BFormSelect
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { addUser, getUser, editUser, getUserGroupOptions, getUserRolesOptions, getUserAvatar, uploadUserAvatar } from '@/api/user'

export default {
  name: 'Detail',
  props: {
	  isEdit:{
		  type: Boolean,
		  default: false
	  }
  },
  components: {
	BMedia,
	BCard,
	BAvatar,
	ValidationProvider,
	ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
	BInputGroup,
	BInputGroupAppend,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
	required,
	vSelect
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userData:{
        userName: "",
        password: null,
		firstName:"",
		lastName:"",
		gender:"",
		nationality:"",
		company:"",
		department:"",
		group:"",
		email:"",
		photoImage:"test",
		roleIdentifier:"",
		language: 1,
      },
	  //头像
	  avatar:null,
	  //组选项
	  groupOptions:[],
	  //角色选项
	  roleOptions:[],
	  //语言选项
	  langOptions:[
		  {id:1, label: "中文"},
		  {id:2, label: "English"},
	  ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
	  localize(this.$i18n.locale)
	  this.getUserGroupOptions()
	  this.getUserRolesOptions()
	  if(this.isEdit){
		this.getUser(this.$route.params.name)
	  }
  },
  methods: {
	//获取组下拉选项
	getUserGroupOptions(){
	  getUserGroupOptions(this.filter).then(response => { 
		this.groupOptions = response.data
	  })
	},  
	//获取用户角色下拉选项
	getUserRolesOptions(){
	  getUserRolesOptions().then(response => { 
		this.roleOptions = response.data
	  })
	}, 
	//用户详情
	getUser(name){
		getUser(name)
		.then(response => {
		  this.userData = response.data
		  this.userData.photoImage = null
		  this.userData.password = null
		  this.getUserAvatar(name)
		})
	},
	//获取用户头像
	getUserAvatar(name){
		getUserAvatar(name)
		.then(response => {
		  this.avatar = URL.createObjectURL(response.data)
		})
	},
	//提交表单
	onSubmit(){	
	  if(this.isEdit){
	    this.editUser()
	  }	
	  else{
		this.addUser()
	  }
	},
    //添加用户
    addUser(){
	  this.$refs.addUserRules.validate().then(success => {
	    if (success) {
	      addUser(this.userData)
	      .then(response => {
	        this.$router.replace({ name: 'users-user-list' })
	            .then(() => {
	              this.$toast({
	                component: ToastificationContent,
	                position: 'top-right',
	                props: {
	                  title: '添加成功',
	                  icon: 'CoffeeIcon',
	                  variant: 'success',
	                  text: '添加用户成功 !',
	                },
	              })
	            })
	      })
	    }
	  })	
		
      
    },
	//编辑用户
	editUser(){
	  this.$refs.addUserRules.validate().then(success => {
	    if (success) {
	      editUser(this.userData)
	      .then(response => {
	        this.$router.replace({ name: 'users-user-list' })
	            .then(() => {
	              this.$toast({
	                component: ToastificationContent,
	                position: 'top-right',
	                props: {
	                  title: '编辑成功',
	                  icon: 'CoffeeIcon',
	                  variant: 'success',
	                  text: '编辑用户成功 !',
	                },
	              })
	            })
	      })
	    }
	  })
	},
	//文件上传
	uploadFile(event) {	
	  uploadUserAvatar({
		PhotoImage:event.target.files[0]
	  })
	  .then(response => {
	    this.userData.photoImage = response.newFileName
		this.avatar = response.url
	  })
	},


  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>